module.exports = __webpack_public_path__ + "img/bitrue-mobile.419f61dc.png";